// removed by extract-text-webpack-plugin
module.exports = {"info":"batch-download-form__info___HYFYi","actions":"batch-download-form__actions___3J-9Z","add-email-container":"batch-download-form__add-email-container___1toh8","add-email_container__text-field-container":"batch-download-form__add-email_container__text-field-container___2HCW0","add-email_container__button-container":"batch-download-form__add-email_container__button-container___TtePH","emails-container":"batch-download-form__emails-container___3WbS8","email-row":"batch-download-form__email-row___2yX3W"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/documents/forms/batch-download-form.scss
// module id = 1326
// module chunks = 0